import type { ReactNode } from "react";

export function ContentHeader({
  title,
  breadcrumb,
  actions,
}: {
  title: string;
  breadcrumb?: string[];
  actions?: ReactNode;
}) {
  return (
    <div className="content-header d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
      <div>
        <h1 className="page-title h3 mb-1">{title}</h1>
        {breadcrumb && (
          <nav aria-label="Trilha">
            <ol className="breadcrumb mb-0">
              {breadcrumb.map((b, i) => (
                <li
                  key={`${i}-${b}`}
                  className={`breadcrumb-item${i === breadcrumb.length - 1 ? " active" : ""}`}
                  aria-current={i === breadcrumb.length - 1 ? "page" : undefined}
                >
                  {b}
                </li>
              ))}
            </ol>
          </nav>
        )}
      </div>
      {actions && <div className="d-flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}
